/**
 * Testimonial Slider Component
 * Handles testimonial carousel functionality with auto-play and manual navigation
 */

export class TestimonialSlider {
  constructor(element) {
    this.element = element;
    this.slides = Array.from(element.querySelectorAll('.testimonial-slide'));
    this.dots = Array.from(element.parentElement.querySelectorAll('.testimonial-dots .dot'));
    this.prevButton = element.querySelector('.slider-arrow-prev');
    this.nextButton = element.querySelector('.slider-arrow-next');
    this.currentIndex = 0;
    this.autoPlayInterval = null;
    this.autoPlayDelay = 8000; // 5 seconds

    this.init();
  }

  init() {
    if (this.slides.length === 0) {
      console.warn('No testimonial slides found');
      return;
    }

    // Set up event listeners
    this.setupEventListeners();

    // Start auto-play
    this.startAutoPlay();

    console.log(`Testimonial slider initialized with ${this.slides.length} slides`);
  }

  setupEventListeners() {
    // Navigation arrows
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.goToPrevious());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.goToNext());
    }

    // Dots navigation
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Pause auto-play on hover
    this.element.addEventListener('mouseenter', () => this.stopAutoPlay());
    this.element.addEventListener('mouseleave', () => this.startAutoPlay());

    // Keyboard navigation
    document.addEventListener('keydown', (e) => this.handleKeyboard(e));
  }

  goToSlide(index) {
    // Remove active class from current slide and dot
    this.slides[this.currentIndex].classList.remove('active');
    this.dots[this.currentIndex].classList.remove('active');

    // Update current index
    this.currentIndex = index;

    // Add active class to new slide and dot
    this.slides[this.currentIndex].classList.add('active');
    this.dots[this.currentIndex].classList.add('active');

    // Reset auto-play timer
    this.resetAutoPlay();
  }

  goToNext() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.goToSlide(nextIndex);
  }

  goToPrevious() {
    const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.goToSlide(prevIndex);
  }

  handleKeyboard(e) {
    if (e.key === 'ArrowLeft') {
      this.goToPrevious();
    } else if (e.key === 'ArrowRight') {
      this.goToNext();
    }
  }

  startAutoPlay() {
    this.stopAutoPlay(); // Clear any existing interval
    this.autoPlayInterval = setInterval(() => {
      this.goToNext();
    }, this.autoPlayDelay);
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }

  resetAutoPlay() {
    this.stopAutoPlay();
    this.startAutoPlay();
  }

  destroy() {
    this.stopAutoPlay();

    // Remove event listeners
    if (this.prevButton) {
      this.prevButton.removeEventListener('click', this.goToPrevious);
    }

    if (this.nextButton) {
      this.nextButton.removeEventListener('click', this.goToNext);
    }

    this.dots.forEach((dot) => {
      dot.removeEventListener('click', () => {});
    });

    console.log('Testimonial slider destroyed');
  }
}

/**
 * Initialize testimonial slider
 * @returns {TestimonialSlider|null}
 */
export function initTestimonialSlider() {
  const sliderElement = document.querySelector('.testimonials-slider');

  if (!sliderElement) {
    return null;
  }

  return new TestimonialSlider(sliderElement);
}
